import { render, staticRenderFns } from "./ExportToLayoutModal.vue?vue&type=template&id=a8b21a4c"
import script from "./ExportToLayoutModal.vue?vue&type=script&lang=js"
export * from "./ExportToLayoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports